import React, {useEffect, useState} from "react";
import {mayBe} from "./utils";
import {DocRow, DocTitle} from "../../components";
import {DocumentsBatch, RefpadoDocument} from "../../types";
import {FlscopyResponse} from "../../types/flscopy";
import {selectedDocument} from "./index";
import {QRFooter} from "../qr_footer/QRFooter";
import {DocTable} from "../../components/doc_table/DocTable";
import {AvailableDocuments} from "./AvailableDocuments";

export const FlscopyDoc: React.FC<{ documents: DocumentsBatch, withVersions?: boolean }> = ({
                                                                                                documents,
                                                                                                withVersions = true
                                                                                            }) => {

    const [selectedDocument, setSelectedDocument] = useState<selectedDocument>(
            {
                document: documents.documents[0],
                documentTypeName: documents.documentsType
            });

    const [doc, setDocument] = useState<FlscopyResponse>(
            selectedDocument.document.document as unknown as FlscopyResponse
    )

    useEffect(() => {
        setDocument(selectedDocument.document.document as FlscopyResponse);
    }, [selectedDocument.document.version])

    const title = `Копия финансового лицевого счёта № ${mayBe(doc?.data.fnum) || 'б/н'}`;
    const subTitle = `${doc.data.flatType} (${doc.data.partType})`;

    const getDocument = (document: RefpadoDocument) => {
        const {documentType, serial = '', number = '', issuedBy = '', issuedDate = ''} = document;
        if (!serial && !number && !issuedBy && !issuedDate) {
            return documentType;
        }
        return `${documentType} ${serial} №${number}, выдан ${issuedBy} от ${issuedDate}`;
    };


    return (
            <>
                <div className="col-span-12 md:col-span-12">
                    <DocTitle title={title} subtitle={subTitle} uid={doc.blockchainUid}/>
                </div>

                <div className="col-span-12 md:col-span-8">
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Наниматель/Собственник" bold value={mayBe(doc.data.ownersFio)}/>
                        <DocRow title="Адрес" bold value={mayBe(doc.data.addrstr)}/>
                        <DocRow title="ФЛС" bold value={mayBe(doc.data.fnum)}/>
                        <DocRow title="Код плательщика" bold value={mayBe(doc.data.pcode) || '-'}/>
                    </div>

                    <DocTable
                            className={'doc-table--m2 bottom-line'}
                            title={'Документы на жилое помещение'}
                            headers={[
                                'Вид документов',
                                '№',
                                'Дата',
                                'Кем выдан',
                                'Запись в ЕГРН'
                            ]}
                            rows={doc.docs.doc.map(d => [
                                mayBe(d.typ) || '-',
                                mayBe(d.num) || '-',
                                mayBe(d.sd) || '-',
                                mayBe(d.who) || '-',
                                mayBe(d.egrpNum) || '-',
                            ])}
                            empty={'-'}/>
                </div>
                {
                        withVersions && documents.documents.length > 0 &&
                        <div className="col-span-12 md:col-end-13 md:col-span-3 order-first md:order-3">
                            <AvailableDocuments
                                    docs={documents}
                                    setSelectedDocument={setSelectedDocument}
                                    className={'md:-mt-12 mb-5'}
                            />
                        </div>
                }
                <div className="col-span-12 md:col-span-8 md:order-last">
                    <DocTitle subtitle={'Удобства'} title={''} className={'doc-title__subtitle--mt-0'}/>
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Отопление" bold value={mayBe(doc.data.otop) || '-'}/>
                        <DocRow title="Водопровод" bold value={mayBe(doc.data.vod) || '-'}/>
                        <DocRow title="Канализация" bold value={mayBe(doc.data.kan) || '-'}/>
                        <DocRow title="Электроснабжение" bold value={mayBe(doc.data.electr) || '-'}/>
                        <DocRow title="Ванна" bold value={mayBe(doc.data.vanna) || '-'}/>
                        <DocRow title="Газ" bold value={mayBe(doc.data.gaz) || '-'}/>
                        <DocRow title="Горячая вода" bold value={mayBe(doc.data.hotWater) || '-'}/>
                        <DocRow title="Лифт" bold value={mayBe(doc.data.lift) || '-'}/>
                        <DocRow title="Этажность" bold value={mayBe(doc.data.houseFloor) || '-'}/>
                        <DocRow title="Год постройки" bold value={mayBe(doc.data.houseYear) || '-'}/>
                    </div>

                    <DocTitle subtitle={'Площадь жилого помещения'} title={''}/>
                    <div className="pl-3 pb-5 bottom-line">
                        <DocRow title="Общая" bold value={mayBe(doc.data.sAllFlat) || '-'}/>
                        <DocRow title="Жилая" bold value={mayBe(doc.data.sGilFlat) || '-'}/>
                        <DocRow title="Жилая заним." bold value={mayBe(doc.data.sGilFls) || '-'}/>
                        <DocRow title="Привед. площадь" bold value={mayBe(doc.data.sPriv) || '-'}/>
                        <DocRow title="Неотапл. площадь" bold value={mayBe(doc.data.sNeot) || '-'}/>
                        <DocRow title="Пл. летних помещ." bold value={mayBe(doc.data.sLet) || '-'}/>
                        <DocRow title="Общая с летн. пом." bold value={mayBe(doc.data.sAllLetFlat) || '-'}/>

                        {
                            doc.kitchens.kitchen.map((k, i) =>
                                    <DocRow key={'k' + i} title={`Кухня ${i + 1}-я`} bold value={mayBe(k) || '-'}/>)
                        }

                        {
                            doc.rooms.room
                                    .map((r) =>
                                            <DocRow key={'r' + r.nom}
                                                    title={`${r.nom} ${r.type}`} bold
                                                    value={mayBe(r.sqr) || '-'}
                                            />)
                        }

                        {
                            doc.rooms.room
                                    .flatMap(r => r.childList.child)
                                    .filter(roomChild => !!roomChild.type)
                                    .map((roomChild, i) =>
                                            <DocRow key={'rc' + i}
                                                    title={`${roomChild.type} ${roomChild.nom}`}
                                                    bold
                                                    value={mayBe(roomChild.sqr) || '-'}
                                            />)
                        }
                    </div>

                    <DocTable
                            className={'doc-table--refdebt-services bottom-line'}
                            title={'Список жителей'}
                            headers={[
                                'ФИО',
                                'Дата рождения',
                                'Родственные отношения',
                                'Доля в праве собственности',
                                'Вид регистрации',
                                'Дата регистрации',
                                'Дата выбытия',
                            ]}
                            rows={doc.people.man.map(p => [
                                mayBe(p.fio) || '-',
                                mayBe(p.birthDate) || '-',
                                mayBe(p.relType) || '-',
                                mayBe(p.per) || '-',
                                mayBe(p.regType) || '-',
                                mayBe(p.regDate) || '-',
                                mayBe(p.unregDate) || '-'
                            ])}
                            empty={'-'}/>

                    <QRFooter blockchainUid={doc.blockchainUid}
                              refDate={doc.data.curdate}
                              mfcInfoName={doc.data.firmName}
                              mfcUserName={doc.data.user}
                    />
                </div>
            </>
    );
};
